var api = require("!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../mini-css-extract-plugin/dist/loader.js??ref--6-1!../../css-loader/dist/cjs.js??ref--6-2!../../sass-loader/dist/cjs.js??ref--6-3!./react-tabs.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};